import PropTypes from 'prop-types';
import { Component } from 'react';
import * as React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import I18n from 'I18n';
import UIButton from 'UIComponents/button/UIButton';
import UITextInput from 'UIComponents/input/UITextInput';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { isFile } from '../utils/FoldersAndFiles';
import validateFolderName from '../utils/validateFolderName';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  objects: ImmutablePropTypes.list.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired
};
export default class AddFolderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: false,
      folderName: '',
      validationMessage: null
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }
  handleConfirm() {
    const {
      onCreate
    } = this.props;
    const {
      isValid,
      folderName
    } = this.state;
    if (isValid) {
      onCreate(folderName.trim());
    }
  }
  handleChange(event) {
    const {
      objects
    } = this.props;
    const folderName = event.target.value;
    if (folderName) {
      const validationError = validateFolderName(folderName);
      const existingName = objects.find(object => {
        return !isFile(object) && (object.get('name') === folderName.trim() || object.get('name') === folderName);
      });
      let validationMessage = null;
      if (validationError) {
        validationMessage = validationError.message;
      } else if (existingName) {
        validationMessage = I18n.text('FileManagerCore.folderNameValidation.existingFolder');
      }
      this.setState({
        isValid: !validationMessage,
        validationMessage,
        folderName
      });
    } else {
      this.setState({
        isValid: false,
        validationMessage: null,
        folderName
      });
    }
  }
  handleKeyUp(event) {
    if (event.key === 'Enter') {
      this.handleConfirm();
    }
  }
  render() {
    const {
      onClose
    } = this.props;
    const {
      isValid,
      validationMessage,
      folderName
    } = this.state;
    return /*#__PURE__*/_jsxs(UIModal, {
      "data-test-id": "add-folder-modal",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsx(H2, {
          children: I18n.text('FileManagerCore.addFolderModal.createFolder')
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx(UIFormControl, {
          error: !!validationMessage,
          validationMessage: validationMessage,
          label: I18n.text('FileManagerCore.addFolderModal.folderName'),
          children: /*#__PURE__*/_jsx(UITextInput, {
            "data-test-id": "add-folder-input",
            autoFocus: true,
            value: folderName,
            onKeyUp: this.handleKeyUp,
            onChange: this.handleChange
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "confirm-add-folder-button",
          use: "primary",
          disabled: !isValid,
          onClick: this.handleConfirm,
          children: I18n.text('FileManagerCore.actions.save')
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onClose,
          children: I18n.text('FileManagerCore.actions.cancel')
        })]
      })]
    });
  }
}
AddFolderModal.propTypes = propTypes;